module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event3/younite-event-en-45d5c01ea94730117cb631034e5c3e4f.png";